import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateJobApi } from "./jobApi";

export const updateJobRequest = createAsyncThunk(
  "updateJobRequest/job",
  async (payload: any) => {
    try {
      const response = await updateJobApi(payload);
      return response;
    } catch (error) {
      throw error;
    }
  }
);

interface IInitialState {
  jobUpdate: any;
  message: string;
  pageIsLoading: boolean;
  isSuccess: boolean;
}

const initialState: IInitialState = {
  jobUpdate: {},
  message: "",
  pageIsLoading: false,
  isSuccess: false,
};

const jobSlice = createSlice({
  name: "job",
  initialState: initialState,
  reducers: {
    resetJobMessage: (state) => {
      state.message = "";
    },
    resetJobSuccess: (state) => {
      state.isSuccess = false;
    },
  },
  extraReducers: (builder) => {
    // get job reducer
    builder.addCase(updateJobRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(updateJobRequest.fulfilled, (state, action) => {
      if (action.payload.status === 1000) {
        state.jobUpdate = action.payload.data;
        state.isSuccess = true;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(updateJobRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const { resetJobMessage, resetJobSuccess } = jobSlice.actions;
export default jobSlice.reducer;
